module.exports = require("./sk-SK.js");